(() => {
  if (window.FoundationGallery) return;
  window.FoundationGallery = {
    update(info, html) {
      const current = info.querySelector('media-gallery');
      const incoming = html.querySelector('media-gallery');
      if (!current || !incoming || incoming.dataset['2423Grouped'] !== 'true') return false;
      if (current.dataset['2423Color'] === incoming.dataset['2423Color']) return true;
      const replacement = incoming.cloneNode(true);
      replacement.id = current.id;
      if (info.dataset.originalSection) {
        const sourceId = info.dataset.originalSection;
        const targetId = info.dataset.section;
        replacement.querySelectorAll('*').forEach(element => {
          for (const name of ['id', 'data-media-id', 'data-target', 'aria-controls', 'aria-describedby', 'href']) {
            const value = element.getAttribute(name);
            if (value) element.setAttribute(name, value.replaceAll(sourceId, targetId));
          }
        });
      }
      current.replaceWith(replacement);
      const modal = info.productModal?.querySelector('.product-media-modal__content');
      const sourceModal = html.querySelector('product-modal .product-media-modal__content');
      if (modal && sourceModal) modal.innerHTML = sourceModal.innerHTML;
      if (info.hasAttribute('data-zoom-on-hover') && typeof enableZoomOnHover === 'function') enableZoomOnHover(2);
      return true;
    }
  };
})();
